/**
 * Implementation of Gatsby Browser APIs and anything common to every part of
 * site.
 *
 * Copyright (c) 2018-2019 Kier Dugan.
 */

import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import {
  faBars,
  faClock,
  faHammer,
  faRssSquare,
  faTags,
 } from '@fortawesome/free-solid-svg-icons'

import '@csstools/normalize.css'

import './src/styles/site.scss'


// =============================================================================
// Make certain icons available site-wide.
library.add(fab, faBars, faClock, faHammer, faRssSquare, faTags)
